// const DEV_API_BASE_URL = "https://devapi.healthetile.net/api/";
// Prod API URL. Use this as DEFAULT_API_BASE_URL when a production API build is required.
const PROD_API_BASE_URL = "https://healthetile.net/api/";

const DEFAULT_API_BASE_URL = PROD_API_BASE_URL;

const normalizeBaseUrl = (baseUrl) => {
  if (!baseUrl) {
    return DEFAULT_API_BASE_URL;
  }

  return baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
};

export const BaseURL = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL);

export const API_CONSTANTS = {
  LOGIN: `${BaseURL}Accounts/Login`,
  LOGOUT: `${BaseURL}Accounts/Logout`,
  MFA_OTP: `${BaseURL}Accounts/ValidateMfaOtp`,
  // Browser navigates here (not XHR); BE 302s to Entra and back to /auth/callback.
  ENTRA_LOGIN: `${BaseURL}Accounts/entra/login`,
  ENTRA_EXCHANGE: `${BaseURL}Accounts/entra/exchange`,
  CHECK_EMAIL_AVAILABILITY: `${BaseURL}Accounts/CheckEmailAvailability`,
  REGISTER: `${BaseURL}Accounts/Register`,
  REFRESH_ACCESS_TOKEN: `${BaseURL}Accounts/RefreshAccessToken`,
  FORGOT_PASSWORD: `${BaseURL}Accounts/ForgotPassword`,
  REQUEST_OTP: `${BaseURL}Accounts/RequestOtp`,
  VERIFY_OTP: `${BaseURL}Accounts/VerifyOtp`,
  PASSWORD_RESET: `${BaseURL}Accounts/PasswordReset`,
  CURRENT_USER: `${BaseURL}Accounts/GetCurrentUser`,
  GET_PROFESSIONAL_DETAILS: `${BaseURL}WebApplication/GetAllProfessionalDetail`,
  HEALTH_PROFESSIONAL: `${BaseURL}WebApplication/AddHealthProfessional`,
  DELETE_HEALTH_PROFESSIONAL: `${BaseURL}WebApplication/DeleteHealthProfessional`,
  GET_PATIENT_DETAILS: `${BaseURL}WebApplication/GetAllPatientdetail`,
  ADD_PATIENT_DETAILS: `${BaseURL}WebApplication/AddPatientDetail`,
  GENDER_DROPDOWN: `${BaseURL}DropDown/GetAllGender`,
  RACE_DROPDOWN: `${BaseURL}DropDown/GetAllRace`,
  EDUCATION_DROPDOWN: `${BaseURL}DropDown/GetAllEducationDegree`,
  GET_PATIENT_BY_ID: `${BaseURL}WebApplication/GetPatientById`,
  UPDATE_HEALTH_PROFESSIONAL_BY_ID: `${BaseURL}WebApplication/UpdateHealthProfessionalById`,
  GET_ALL_DEVICE_FOR_ADMIN: `${BaseURL}DropDown/GetAllDeviceForAdmin`,
  ADD_DEVICE_FOR_HEALTH_PROFESSIONAL: `${BaseURL}Admin/AddDevice`,
  UPDATE_DEVICE_BY_ID: `${BaseURL}Admin/UpdateDevice`,
  DELETE_DEVICE_BY_ID: `${BaseURL}Admin/DeleteDeviceById`,
  GET_DEVICE_BY_ID: `${BaseURL}Admin/GetDeviceById`,

  GET_ALL_DEVICE: `${BaseURL}Admin/GetAllDevice`,
  GET_ALL_DEVICE_LOGS: `${BaseURL}Admin/GetAllDeviceForLogs`,
  GET_DEVICE_ASSIGNED_PROFESSION_BY_ID: `${BaseURL}DropDown/GetDeviceAssignedForHealthProfessional`,
  UPDATE_PATIENT_DETAILS: `${BaseURL}WebApplication/UpdatePatientDetail`,
  DELETE_PATIENT_BY_ID: `${BaseURL}WebApplication/DeletePatient`,
  ADD_PATIENT_NOTE: `${BaseURL}WebApplication/AddNote`,
  GET_PATIENT_NOTE: `${BaseURL}WebApplication/GetAllNotes`,
  DELETE_PATIENT_NOTE_BY_ID: `${BaseURL}WebApplication/DeletNoteById`,
  GET_VITAL_VALUES_FOR_GRAPH: `${BaseURL}DataProcess/GetVitalValuesForGraph`,
  UPDATE_HEALTH_PROFESSIONAL_PROFILE: `${BaseURL}WebApplication/UpdateHealthProfessional`,
  GET_SESSION_DETAIL: `${BaseURL}DataProcess/GetAllSessionMetaData`,
  DOWNLOAD_EXCEL_VITAL_VALUES: `${BaseURL}WebApplication/GetCSVReport`,
  DELETE_SESSION_DETAIL: `${BaseURL}DataProcess/DeleteSessionDetail`,
  GET_HP_DASHBOARD_DATA: `${BaseURL}DashBoard/GetHealthProfessionalDashBoardData`,
  GET_ADMIN_DASHBOARD_DATA: `${BaseURL}DashBoard/GetAdminDashBoardData`,
  GET_HEALTH_PROFESSIONAL_BY_ID: `${BaseURL}WebApplication/GetHealthProfressionalById`,
  GET_SESSION_TOTAL_COUNT: `${BaseURL}DataProcess/GetSessionDetailCount`,
  GET_ALL_REFERENCE_DROPDOWN: `${BaseURL}DropDown/GetReferenceId`,
  GET_CALENDAR_DATA: `${BaseURL}DataProcess/GetDataForCalendar`,
  GET_CALENDAR_DATA_FOR_LOGS: `${BaseURL}Admin/GetLogDateForCalendarForSuperAdmin`,
  GET_HP_CALENDAR_DATA_FOR_LOGS: `${BaseURL}WebApplication/GetLogDateForCalendarForHealthProfessional`,
  GET_REFERENCE_DATA: `${BaseURL}DataProcess/GetSessionData`,
  CSV_DOWNLOAD_HANDLER: `${BaseURL}DataProcess/CSVFileDownloadHandler`,
  PROCESS_RAW_CSV_FILE: `${BaseURL}DataProcess/ProcessRawCSVFile`,
  GET_JOB_STATUS: `${BaseURL}DataProcess/GetJobStatus`,
  GET_API_KEY_LIST: `${BaseURL}ApiKey/GetAppTypesList`,
  ADD_OR_UPDATE_APP_KEY: `${BaseURL}ApiKey/AddOrUpdateAppKeys`,
  GET_APP_KEYS: `${BaseURL}ApiKey/GetAppKeys`,
  GET_ALL_PATIENTS_SUPERADMIN: `${BaseURL}Admin/GetAllPatientdetailForSuperAdmin`,
  GET_ALL_ACTIVITY_LOG_BY_ID: `${BaseURL}Admin/GetAllActivityLogs`,
  GET_ALL_PATIENTS_HP: `${BaseURL}webApplication/GetAllPatientdetailForLogs`,
  GET_ALL_DEVICE_HP: `${BaseURL}webApplication/GetAllDeviceForHealthProfessional`,
  GET_ALL_ACTIVITY_LOG_HP_BY_ID: `${BaseURL}webApplication/GetAllActivityLogsForHealthProfessional`,

  CONFIRM_DEVICE_REMOVAL: `${BaseURL}Admin/ConfirmDeviceRemovalForHealthProfessional`,
  CONFIRM_DEVICE_REASSIGNMENT: `${BaseURL}Admin/ConfirmDeviceReassignment`,
  GET_ALL_HEALTH_PROFESSIONAL_ID: `${BaseURL}DropDown/GetAllHealthProfessionalIds`,
  READ_JSON_FILE_FOR_VITAL_VALUES: `${BaseURL}DataProcess/ReadJsonFileForVitalValues`,
  UPDATE_SUPER_ADMIN_PROFILE: `${BaseURL}Admin/UpdateSuperAdminProfile`,
  SAVE_SURVEY: `${BaseURL}WebApplication/SaveSurvey`,
  GET_ALL_SURVEYS: `${BaseURL}WebApplication/GetAllSurveys`,
  GET_SURVEY_BY_ID: `${BaseURL}WebApplication/GetSurveyById`,
  ASSIGN_SURVEY: `${BaseURL}WebApplication/AssignSurvey`,
  GET_SURVEY_ASSIGNMENTS: `${BaseURL}WebApplication/GetSurveyAssignments`,
  REVOKE_SURVEY_ASSIGNMENT: `${BaseURL}WebApplication/RevokeSurveyAssignment`,
  DOWNLOAD_SURVEY_JSON: `${BaseURL}WebApplication/DownloadSurveyJson`,
  GET_SURVEY_SUBMISSION_BY_ID: `${BaseURL}WebApplication/GetSurveySubmissionById`,
  GET_ALL_SURVEY_IDS: `${BaseURL}DropDown/GetAllSurveyIds`,
  GET_SURVEY_HISTORY_BY_PATIENT_ID: `${BaseURL}WebApplication/GetSurveyHistoryByPatientId`,

  SAVE_APP_VERSION: `${BaseURL}Admin/SaveAppVersion`,
  GET_ALL_APP_VERSIONS: `${BaseURL}Admin/GetAllAppVersions`,
  GET_APP_VERSION: `${BaseURL}MobileApplication/GetAppVersion`,
};

export const API_METHODS = {
  GET: "GET",
  POST: "POST",
  DELETE: "DELETE",
};
